import { z } from 'zod';
import { MessengerSchema } from '../events/messenger-outcome';

/**
 * The operator's messenger chat list and detail (IMM-1127.1): one row per
 * `messenger_member_links` row, ended links included.
 */
export const MessengerChatListItemSchema = z.object({
  chatId: z.uuid(),
  messenger: MessengerSchema,
  /** The E.164 number, or the Telegram @username / name captured at connect. */
  account: z.string(),
  memberId: z.uuid(),
  memberName: z.string().nullable(),
  workspaceId: z.uuid(),
  workspaceName: z.string().nullable(),
  lastMessageAt: z.iso.datetime().nullable(),
});
export type MessengerChatListItem = z.infer<typeof MessengerChatListItemSchema>;

export const ListMessengerChatsResponseSchema = z.object({
  data: z.array(MessengerChatListItemSchema),
  truncated: z.boolean(),
});
export type ListMessengerChatsResponse = z.infer<typeof ListMessengerChatsResponseSchema>;

export const MESSENGER_CHAT_MESSAGE_CAP = 5000;

export const MessengerChatMessageSchema = z.object({
  id: z.uuid(),
  direction: z.enum(['INBOUND', 'OUTBOUND']),
  body: z.string(),
  occurredAt: z.iso.datetime(),
});
export type MessengerChatMessage = z.infer<typeof MessengerChatMessageSchema>;

export const GetMessengerChatPathParamsSchema = z.object({ chatId: z.uuid() });

export const GetMessengerChatResponseSchema = z.object({
  chatId: z.uuid(),
  messenger: MessengerSchema,
  account: z.string(),
  member: z.object({ memberId: z.uuid(), name: z.string().nullable(), email: z.string().nullable() }),
  workspace: z.object({ workspaceId: z.uuid(), name: z.string().nullable() }),
  messages: z.array(MessengerChatMessageSchema),
  truncated: z.boolean(),
});
export type GetMessengerChatResponse = z.infer<typeof GetMessengerChatResponseSchema>;
